import { localizeWithPath } from '../../../../nls.js';
import { languagesExtPoint } from '../../../services/language/common/languageService.js';
import { Extensions } from '../../../services/extensionManagement/common/extensionFeatures.js';
import { Disposable } from '../../../../base/common/lifecycle.js';
import { SyncDescriptor } from '../../../../platform/instantiation/common/descriptors.js';
import { Registry } from '../../../../platform/registry/common/platform.js';
import { MarkdownString } from '../../../../base/common/htmlContent.js';
const _moduleId = "vs/workbench/contrib/codeActions/common/codeActionsExtensionPoint";
var CodeActionExtensionPointFields;
( ((function(CodeActionExtensionPointFields) {
    CodeActionExtensionPointFields["languages"] = "languages";
    CodeActionExtensionPointFields["actions"] = "actions";
    CodeActionExtensionPointFields["kind"] = "kind";
    CodeActionExtensionPointFields["title"] = "title";
    CodeActionExtensionPointFields["description"] = "description";
})(CodeActionExtensionPointFields || (CodeActionExtensionPointFields = {}))));
const codeActionsExtensionPointSchema = ( (Object.freeze({
    type: 'array',
    markdownDescription: ( localizeWithPath(_moduleId, 0, "Configure which editor to use for a resource.")),
    items: {
        type: 'object',
        required: [CodeActionExtensionPointFields.languages, CodeActionExtensionPointFields.actions],
        properties: {
            [CodeActionExtensionPointFields.languages]: {
                type: 'array',
                description: ( localizeWithPath(_moduleId, 1, "Language modes that the code actions are enabled for.")),
                items: { type: 'string' }
            },
            [CodeActionExtensionPointFields.actions]: {
                type: 'object',
                required: [CodeActionExtensionPointFields.kind, CodeActionExtensionPointFields.title],
                properties: {
                    [CodeActionExtensionPointFields.kind]: {
                        type: 'string',
                        markdownDescription: ( localizeWithPath(_moduleId, 2, "`CodeActionKind` of the contributed code action.")),
                    },
                    [CodeActionExtensionPointFields.title]: {
                        type: 'string',
                        description: ( localizeWithPath(_moduleId, 3, "Label for the code action used in the UI.")),
                    },
                    [CodeActionExtensionPointFields.description]: {
                        type: 'string',
                        description: ( localizeWithPath(_moduleId, 4, "Description of what the code action does.")),
                    },
                }
            }
        }
    }
})));
const codeActionsExtensionPointDescriptor = {
    extensionPoint: 'codeActions',
    deps: [languagesExtPoint],
    jsonSchema: codeActionsExtensionPointSchema
};
class CodeActionsTableRenderer extends Disposable {
    constructor() {
        super(...arguments);
        this.type = 'table';
    }
    shouldRender(manifest) {
        return !!manifest.contributes?.codeActions;
    }
    render(manifest) {
        const codeActions = manifest.contributes?.codeActions || [];
        if (!codeActions.length) {
            return { data: { headers: [], rows: [] }, dispose: () => { } };
        }
        const flatActions = ( (codeActions.map(
            contribution => ( (contribution.actions.map(action => ({ ...action, languages: contribution.languages }))))
        ))).flat();
        const headers = [
            ( localizeWithPath(_moduleId, 5, "Title")),
            ( localizeWithPath(_moduleId, 6, "Kind")),
            ( localizeWithPath(_moduleId, 7, "Description")),
            ( localizeWithPath(_moduleId, 8, "Languages"))
        ];
        const rows = ( (flatActions.sort((a, b) => a.title.localeCompare(b.title))
            .map(action => {
            return [
                action.title,
                ( (new MarkdownString())).appendMarkdown(`\`${action.kind}\``),
                action.description ?? '',
                ( (new MarkdownString())).appendMarkdown(`${( (action.languages.map(lang => `\`${lang}\``))).join('&nbsp;')}`),
            ];
        })));
        return {
            data: {
                headers,
                rows
            },
            dispose: () => { }
        };
    }
}
( (Registry.as(Extensions.ExtensionFeaturesRegistry))).registerExtensionFeature({
    id: 'codeActions',
    label: ( localizeWithPath(_moduleId, 9, "Code Actions")),
    access: {
        canToggle: false,
    },
    renderer: ( (new SyncDescriptor(CodeActionsTableRenderer))),
});
export { codeActionsExtensionPointDescriptor };
